<template>
  <span
    :class="getStatusClasses"
  >
    <span
      v-if="statusPrefix"
    >
      {{ statusPrefix }}
    </span>
    {{ getStatusName }}
  </span>
</template>
<script>
import PurchaseMixin from '@/mixins/PurchaseMixin'

export default {
  computed: {
    purchaseStatus () {
      return this.purchase ? this.purchase.status : this.status
    },

    getStatusClasses () {
      return this.statusClasses(this.purchaseStatus)
    },

    getStatusName () {
      return this.statusName(this.purchaseStatus)
    }
  },

  mixins: [
    PurchaseMixin
  ],

  props: {
    purchase: {
      type: Object,
      default: () => {}
    },

    status: {
      type: String,
      default: 'pending'
    },

    statusPrefix: {
      type: String,
      default: undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchaseStatusBadge.vue